import { useCallback } from 'react'

import { useAppDispatch, useAppSelector } from 'src/Hooks/redux'
import {
  ThemeMode,
  setTheme,
  getThemeMode,
  getResolvedTheme,
} from 'src/Redux/theme-process'

interface UseThemeModeReturn {
  themeMode: ThemeMode
  resolvedTheme: 'light' | 'dark'
  setThemeMode: (mode: ThemeMode) => void
}

export const useThemeMode = (): UseThemeModeReturn => {
  const dispatch = useAppDispatch()
  const themeMode = useAppSelector(getThemeMode)
  const resolvedTheme = useAppSelector(getResolvedTheme)

  const setThemeMode = useCallback(
    (mode: ThemeMode) => {
      dispatch(setTheme(mode))
    },
    [dispatch],
  )

  return {
    themeMode,
    resolvedTheme,
    setThemeMode,
  }
}
